import React, { useState } from "react";
import { Modal, Upload, Button, message, Spin, Divider } from "antd";
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons";
import usePersonnelInfoService from "../../../../services/usePersonnelInfoService";

const { Dragger } = Upload;

const ImageUploadModal = ({ visible, onClose, onSuccess, currentImageUrl }) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const { useUploadImage, useDeleteImage } = usePersonnelInfoService();
  const { mutateAsync: uploadImage } = useUploadImage();
  const { mutateAsync: deleteImage } = useDeleteImage();

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Sadece Fotoğraf Tipinde Dosya Yükleyebilirsiniz");
      return false;
    }

    const isLt3M = file.size / 1024 / 1024 < 5;
    if (!isLt3M) {
      message.error("Fotoğraf 5MB'dan küçük olmalıdır!");
      return false;
    }
    return true;
  };

  const handleUpload = async () => {
    if (fileList.length === 0) return;

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("image", fileList[0].originFileObj);

      await uploadImage(formData);
      setFileList([]);
      onSuccess?.();
      onClose();
    } catch (error) {
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setFileList([]);
  };

  const handleDeleteCurrentImage = async () => {
    try {
      setDeleting(true);
      await deleteImage();
      onSuccess?.();
      message.success("Fotoğraf başarıyla silindi");
      onClose();
    } catch (error) {
      message.error("Fotoğraf silinirken bir hata oluştu");
    } finally {
      setDeleting(false);
    }
  };

  const uploadProps = {
    beforeUpload,
    fileList,
    onChange: ({ fileList: newFileList }) => {
      setFileList(newFileList);
    },
    onRemove: handleRemove,
    maxCount: 1,
    multiple: false,
    showUploadList: false,
    accept: "image/*",
  };

  return (
    <Modal
      title="Fotoğrafını Yükle"
      open={visible}
      onCancel={onClose}
      width={600}
      footer={[
        <Button key="cancel" onClick={onClose}>
          İptal
        </Button>,
        <Button
          key="upload"
          type="primary"
          onClick={handleUpload}
          disabled={fileList.length === 0}
          loading={uploading}
          style={{
            border: "none",
          }}>
          Kaydet
        </Button>,
      ]}>
      <div>
        {/* Current Image Section */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <div
            style={{
              width: "150px",
              height: "150px",
              margin: "0 auto 16px auto",
              borderRadius: "8px",
              overflow: "hidden",
            }}>
            <img
              src={currentImageUrl}
              alt="Current Avatar"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={handleDeleteCurrentImage}
            loading={deleting}>
            Fotoğrafı Sil
          </Button>
        </div>

        <Divider />

        {/* Upload Section */}
        <div style={{ position: "relative" }}>
          <Dragger {...uploadProps} style={{ padding: "20px" }}>
            {fileList.length > 0 ? (
              <div
                style={{
                  position: "relative",
                  width: "250px",
                  height: "250px",
                  margin: "0 auto",
                }}>
                <img
                  src={URL.createObjectURL(fileList[0].originFileObj)}
                  alt="New Avatar"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <Button
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemove();
                  }}
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    borderRadius: "50%",
                    padding: "8px",
                    background: "rgba(0, 0, 0, 0.5)",
                    border: "none",
                    color: "white",
                  }}
                />
              </div>
            ) : (
              <div>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Buraya sürükle ya da Yükle</p>
                <p className="ant-upload-hint" style={{ color: "#6b7280" }}>
                  Fotoğrafın en fazla 5MB büyüklüğünde olmalıdır.
                </p>
              </div>
            )}
          </Dragger>
        </div>
      </div>
    </Modal>
  );
};

export default ImageUploadModal;
